import { useGet } from "../useApi";

export const CAPABILITIES_QUERY_KEY = "capabilities";

export function getCapabilities(scope = "", options = {}) {
  return useGet(`${CAPABILITIES_QUERY_KEY}-${scope}`, "capabilities", {}, {
    staleTime: 5 * 60 * 1000,
    retry: false,
    ...options,
  });
}
